import React from 'react';
import { saveAs } from 'file-saver';
import Timer from 'easytimer.js';
import { Ring } from 'react-css-spinners';
import { createBrowserHistory } from 'history';
import CountrySelect from 'react-simple-country-select';

import { firebase } from './db';
import logo from './harmony-logo-horizontal-full-color.svg';
import styles from './app.module.scss';
import { binace_field_provided, binace_field_not_provided } from './binance-field-message';

const history = createBrowserHistory();

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const INVALID_EMAIL = <p className={styles.errorMessage}>Please enter a valid email</p>;

const EMAIL_ALREADY_CLAIMED = <p className={styles.errorMessage}>Email already claimed</p>;

const USER_NEVER_VERIFIED_ACCOUNT = <p className={styles.errorMessage}>Email never verified</p>;

const VERIFICATION_TIME_LIMIT = <p className={styles.errorMessage}>Pin expired</p>;

const EMAIL_OR_COUPON_WRONG = (
  <p className={styles.errorMessage}>Either your email or coupon code is wrong</p>
);

const did_verify_screen = binace_field => (
  <section>{binace_field !== '' ? binace_field_provided : binace_field_not_provided}</section>
);

class WithMaybeBinanceID extends React.Component {
  state = { error_message: null, country_of_origin: 'US' };

  user_name_ref = React.createRef();
  user_email_ref = React.createRef();
  binance_id_ref = React.createRef();
  discord_handle_ref = React.createRef();

  // radio refs
  radio_one_ref = React.createRef();
  radio_two_ref = React.createRef();
  radio_three_ref = React.createRef();

  which_radio_picked = () => {
    // Know this function is safe because form doesn't let
    // submit go through because at least one of the radio buttons says required
    const e = this.radio_one_ref;
    for (const radio of [
      this.radio_one_ref.current,
      this.radio_two_ref.current,
      this.radio_three_ref.current,
    ]) {
      if (radio.checked === true) return radio.value;
    }
  };

  submit = e => {
    e.preventDefault();
    const { country_of_origin } = this.state;
    console.log({ country_of_origin });
    const user_name = this.user_name_ref.current.value.trim();
    const user_email = this.user_email_ref.current.value.trim();
    const binance_id = this.binance_id_ref.current.value.trim();
    const discord_id = this.discord_handle_ref.current.value.trim();
    const radio_value_picked = this.which_radio_picked();
    const { initial_user_signup } = this.props;
    initial_user_signup(
      { user_name, user_email, binance_id, country_of_origin, discord_id, radio_value_picked },
      () => {
        this.setState({ error_message: EMAIL_ALREADY_CLAIMED });
      }
    );
  };

  render() {
    const { error_message, country_of_origin } = this.state;
    const country_setter = ({ target: { value } }) => this.setState({ country_of_origin: value });
    return (
      <div>
        <h3 className={styles.bannerPrompt}>Enter your details</h3>
        <form className={styles.couponCodeEntryForm} onSubmit={this.submit} formNoValidate={true}>
          <section className={styles.formWrapper}>
            <div>
              {error_message}
              <div className={styles.formInputContainer}>
                <input required={true} defaultValue={''} type="text" ref={this.user_name_ref} />
                <label className={styles.formInputLabel}>Name</label>
              </div>
              <div className={styles.formInputContainer}>
                <input required={true} defaultValue={''} type="text" ref={this.user_email_ref} />
                <label className={styles.formInputLabel}>Email</label>
              </div>
              <div className={styles.formInputContainer}>
                <label className={styles.countrySelectLabel}>Location</label>
                <CountrySelect
                  required={true}
                  defaultValue={country_of_origin}
                  className={styles.countrySelectDropdown}
                  onChange={country_setter}
                />
              </div>
              <div className={styles.optionalInformationWrapper}>
                <div className={styles.formInputContainer}>
                  <input
                    required={false}
                    type="text"
                    className={styles.offsetForOptionals}
                    ref={this.binance_id_ref}
                  />
                  <label className={styles.formInputLabel}>Binance ID</label>
                </div>
                <div className={styles.formInputContainer}>
                  <input
                    required={false}
                    type="text"
                    className={styles.offsetForOptionals}
                    ref={this.discord_handle_ref}
                  />
                  <label className={styles.formInputLabel}>Discord ID (optional)</label>
                </div>
              </div>
            </div>

            <div className={styles.radioButtonBlock}>
              <p>Have you run a 'blockchain' node before?</p>
              <div className={styles.radioButtonWrapper}>
                <div className={styles.radioButtonRow}>
                  <input
                    required={true}
                    type="radio"
                    ref={this.radio_one_ref}
                    name="blockchain_q"
                    value="no_but_know_basics_of_blockchain"
                  />
                  <label>No - But I know some basics</label>
                </div>
                <div className={styles.radioButtonRow}>
                  <input
                    type="radio"
                    ref={this.radio_two_ref}
                    name="blockchain_q"
                    value="yes_heard_blockchain"
                  />
                  <label>Yes, I have run nodes for other blockchains</label>
                </div>
                <div className={styles.radioButtonRow}>
                  <input
                    type="radio"
                    ref={this.radio_three_ref}
                    name="blockchain_q"
                    value="never_heard_blockchain"
                  />
                  <label>A what???</label>
                </div>
              </div>
            </div>
            <div className={styles.formInputContainer}>
              <input type="submit" value={'Sign up'} />
            </div>
          </section>
        </form>
      </div>
    );
  }
}

class Verification extends React.Component {
  verification_pin = React.createRef();
  timer = new Timer();
  state = { error_message: null, time_left: `5:00` };

  submit = e => {
    e.preventDefault();
    const { time_left } = this.state;
    // Person waited too long
    if (time_left === null) {
      return;
    }
    const temp_pin = this.verification_pin.current.value.trim();
    const { handle_verification_submit } = this.props;
    handle_verification_submit(temp_pin);
  };

  componentDidMount() {
    const { timer } = this;
    this.timer.start({ countdown: true, startValues: { minutes: 5 } });
    timer.addEventListener('secondsUpdated', () => {
      const { minutes, seconds } = timer.getTimeValues();
      this.setState({ time_left: `${minutes}:${seconds >= 10 ? seconds : `0${seconds}`}` });
    });
    timer.addEventListener('targetAchieved', () => {
      this.setState({ time_left: null, error_message: VERIFICATION_TIME_LIMIT });
    });
  }

  componentWillUnmount() {
    this.timer.stop();
  }

  render() {
    const { time_left, error_message } = this.state;
    return (
      <section>
        <h3 className={styles.bannerPrompt}>Enter your verification {time_left}</h3>
        <form className={styles.couponCodeEntryForm} onSubmit={this.submit}>
          {error_message}
          <p className={styles.verificationPinPrompt}>Check your email for your verification pin</p>
          <div className={styles.formInputContainer}>
            <input required={true} defaultValue={''} type="text" ref={this.verification_pin} />
            <label className={styles.formInputLabel}>Verification Pin</label>
          </div>
          <div className={styles.formInputContainer}>
            <input type="submit" value={'Submit'} />
          </div>
        </form>
      </section>
    );
  }
}

class CouponRedemption extends React.Component {
  state = { error_message: null };

  user_email_ref = React.createRef();
  coupon_code_ref = React.createRef();

  submit = e => {
    e.preventDefault();
    const user_email = this.user_email_ref.current.value.trim();
    const coupon_code = this.coupon_code_ref.current.value.trim();
    const { handle_coupon_entry_submit } = this.props;
    if (EMAIL_REGEX.test(user_email) === false) {
      return this.setState({ error_message: INVALID_EMAIL });
    }
    handle_coupon_entry_submit(user_email, coupon_code, () => {
      this.setState({ error_message: EMAIL_ALREADY_CLAIMED });
    });
  };

  render() {
    const { error_message } = this.state;
    return (
      <section className={styles.pangaeaNodePKGWrapper}>
        <h3 className={styles.bannerPrompt}>Download your Pangaea node keys</h3>
        <form className={styles.couponCodeEntryForm} onSubmit={this.submit}>
          {error_message}
          <div className={styles.formInputContainer}>
            <input required={true} defaultValue={''} type="text" ref={this.user_email_ref} />
            <label className={styles.formInputLabel}>Email</label>
          </div>
          <div className={styles.formInputContainer}>
            <input required={true} defaultValue={''} type="text" ref={this.coupon_code_ref} />
            <label className={styles.formInputLabel}>Pangaea Code</label>
          </div>
          <div className={styles.formInputContainer}>
            <input type="submit" value={'Submit'} />
          </div>
        </form>
      </section>
    );
  }
}

const DEFAULT_STATE = {
  failure_message: null,
  user_needs_verification: null,
  user_email: null,
  coupon_code: null,
  user_db_key: null,
  binance_id: null,
  network_activity: false,
};

export default class Application extends React.Component {
  componentDidMount() {
    if (process.env.NODE_ENV === 'production') {
      window.BUILD_COMMIT = process.env.REACT_APP_BUILD_COMMIT;
    }
  }

  handle_coupon_entry_submit = async (user_email, coupon_code, error_handler) => {
    const download_wallet = firebase.functions().httpsCallable('download_wallet');
    const {
      data: { result, action, reason, payload },
    } = await download_wallet({ user_email, coupon_code });

    console.log({ result, action, reason, payload });
    if (result === 'success') {
      const blob = new Blob([payload], { type: 'application/json;charset=utf-8' });
      saveAs(blob, 'credentials.json');
      setTimeout(this.reset_interface, 5000);
    } else if ('failure') {
      this.setState({ failure_message: EMAIL_OR_COUPON_WRONG }, () => {
        switch (reason) {
          case 'USER_NEVER_VERIFIED_PIN':
            return error_handler();
          case 'USER_DOES_NOT_EXIST':
        }
      });
    }
  };

  handle_verification_submit = temp_pin => {
    this.setState({ network_activity: true }, async () => {
      const { user_email, user_db_key, binance_id } = this.state;
      console.log(this.state);
      const verify_user = firebase.functions().httpsCallable('verify_user');
      const {
        data: { result, action, reason },
      } = await verify_user({ user_email, temp_pin, user_db_key });
      this.setState({ network_activity: false }, () => {
        if (result === 'success') {
          this.setState(
            { content_page: did_verify_screen(binance_id), failure_message: null },
            () => {
              //
            }
          );
          // Auto start downloading the payload?
        } else if (result === 'failure') {
          this.setState({ failure_message: <p>Cannot verify because {reason}</p> });
        } else {
          // Unknown state
        }
        console.log(temp_pin);
      });
    });
  };

  handle_initial_user_signup = (
    { user_name, user_email, binance_id, country_of_origin, discord_id, radio_value_picked },
    email_already_claimed
  ) => {
    this.setState({ network_activity: true, binance_id }, async () => {
      const initial_user_signup = firebase.functions().httpsCallable('initial_user_signup');
      const {
        data: { result, action, payload, reason },
      } = await initial_user_signup({
        user_name,
        user_email,
        binance_id,
        country_of_origin,
        discord_id,
        blockchain_question: radio_value_picked,
      });
      this.setState({ network_activity: false }, () => {
        if (result === 'success') {
          switch (action) {
            case 'DID_SEND_TEMP_PIN':
              this.setState({
                failure_message: null,
                user_needs_verification: true,
                user_email,
                user_db_key: payload,
                content_page: (
                  <Verification handle_verification_submit={this.handle_verification_submit} />
                ),
              });
              break;
            default:
              console.warn(`Unknown action ${action}`);
          }
          console.log(action);
        } else if (result === 'failure') {
          switch (reason) {
            case 'EMAIL_ALREADY_CLAIMED':
              return email_already_claimed();
            case 'USER_EXISTS_BUT_NEVER_VERIFIED':
              this.setState({
                failure_message: null,
                user_needs_verification: true,
                user_email,
                user_db_key: payload,
                content_page: (
                  <Verification handle_verification_submit={this.handle_verification_submit} />
                ),
              });
          }
          // Some kind of failure
        } else {
          console.error(`Unknown result: ${result}`);
          // Unknown case
        }
      });
    });
  };

  initial_component = () =>
    history.location.pathname === '/pkg' ? (
      <CouponRedemption handle_coupon_entry_submit={this.handle_coupon_entry_submit} />
    ) : (
      <WithMaybeBinanceID initial_user_signup={this.handle_initial_user_signup} />
    );

  // HACK: Must have state be defined AFTER handle_coupon_entry_submit is defined
  state = {
    // content_page: binace_field_provided,
    // content_page: <CouponRedemption handle_coupon_entry_submit={this.handle_coupon_entry_submit} />,
    content_page: this.initial_component(),
    ...DEFAULT_STATE,
  };

  reset_interface = () => {
    this.setState({
      content_page: <WithMaybeBinanceID initial_user_signup={this.handle_initial_user_signup} />,
      ...DEFAULT_STATE,
    });
  };

  render() {
    const { user_needs_verification, failure_message, content_page, network_activity } = this.state;
    return (
      <main className={styles.couponFormContainer}>
        <section className={styles.couponFormColumn}>
          <span className={styles.logoWithSpinnerWrapper}>
            <img
              title={'Restart coupon redemption process'}
              onClick={this.reset_interface}
              src={logo}
              className={styles.harmonyLogo}
              alt="Harmony logo"
            />
            {network_activity && <Ring className={styles.spinner} color={'lightgrey'} />}
          </span>
          {failure_message}
          {content_page}
        </section>
      </main>
    );
  }
}
